<template>
  <div class="flex-1 overflow-auto p-4">
    <woot-button
      color-scheme="success"
      class-names="button--fixed-top"
      icon="add-circle"
      @click="openAddPopup()"
    >
      {{ $t('CRM_CONFIGS.HEADER_BTN_TXT') }}
    </woot-button>

    <div class="flex flex-row gap-4">
      <div class="w-[60%]">
        <p
          v-if="!uiFlags.fetchingList && !records.length"
          class="flex h-full items-center flex-col justify-center"
        >
          {{ $t('CRM_CONFIGS.LIST.404') }}
        </p>
        <woot-loading-state
          v-if="uiFlags.fetchingList"
          :message="$t('CRM_CONFIGS.LOADING')"
        />

        <table
          v-if="!uiFlags.fetchingList && records.length"
          class="woot-table"
        >
          <thead>
            <th
              v-for="thHeader in $t('CRM_CONFIGS.LIST.TABLE_HEADER')"
              :key="thHeader"
            >
              {{ thHeader }}
            </th>
          </thead>
          <tbody>
            <tr v-for="(configObj, index) in records" :key="configObj.id">
              <td>{{ configObj.name }}</td>
              <td :title="configObj.api_link">
                {{
                  configObj.api_link.length > 30
                    ? configObj.api_link.substring(0, 30) + '...'
                    : configObj.api_link
                }}
              </td>
              <td :title="configObj.token" class="font-mono text-xs">
                {{
                  configObj.token.length > 30
                    ? configObj.token.substring(0, 30) + '...'
                    : configObj.token
                }}
              </td>
              <td class="button-wrapper">
                <woot-button
                  v-tooltip.top="$t('CRM_CONFIGS.EDIT.BUTTON_TEXT')"
                  variant="smooth"
                  size="tiny"
                  color-scheme="secondary"
                  icon="edit"
                  @click="openEditPopup(configObj)"
                />
                <woot-button
                  v-tooltip.top="$t('CRM_CONFIGS.DELETE.BUTTON_TEXT')"
                  variant="smooth"
                  color-scheme="alert"
                  size="tiny"
                  icon="dismiss-circle"
                  class-names="grey-btn"
                  :is-loading="loading[configObj.id]"
                  @click="openDeletePopup(configObj, index)"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="w-[34%]">
        <span v-dompurify-html="$t('CRM_CONFIGS.SIDEBAR_TXT')" />
      </div>
    </div>

    <woot-modal :show.sync="showAddPopup" :on-close="hideAddPopup">
      <add-crm-config :on-close="hideAddPopup" />
    </woot-modal>

    <woot-modal :show.sync="showEditPopup" :on-close="hideEditPopup">
      <edit-crm-config
        v-if="showEditPopup"
        :id="selectedConfig.id"
        :edname="selectedConfig.name"
        :edapilink="selectedConfig.api_link"
        :edtoken="selectedConfig.token"
        :on-close="hideEditPopup"
      />
    </woot-modal>

    <woot-delete-modal
      :show.sync="showDeleteConfirmationPopup"
      :on-close="closeDeletePopup"
      :on-confirm="confirmDeletion"
      :title="$t('CRM_CONFIGS.DELETE.CONFIRM.TITLE')"
      :message="$t('CRM_CONFIGS.DELETE.CONFIRM.MESSAGE')"
      :message-value="deleteMessage"
      :confirm-text="deleteConfirmText"
      :reject-text="deleteRejectText"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import AddCrmConfig from './AddCrmConfig.vue';
import EditCrmConfig from './EditCrmConfig.vue';

export default {
  components: {
    AddCrmConfig,
    EditCrmConfig,
  },
  data() {
    return {
      loading: {},
      showAddPopup: false,
      showEditPopup: false,
      showDeleteConfirmationPopup: false,
      selectedConfig: {},
    };
  },
  computed: {
    ...mapGetters({
      records: 'crmConfigs/getRecords',
      uiFlags: 'crmConfigs/getUIFlags',
    }),
    deleteConfirmText() {
      return `${this.$t('CRM_CONFIGS.DELETE.CONFIRM.YES')} ${
        this.selectedConfig.name
      }`;
    },
    deleteRejectText() {
      return `${this.$t('CRM_CONFIGS.DELETE.CONFIRM.NO')} ${
        this.selectedConfig.name
      }`;
    },
    deleteMessage() {
      return ` ${this.selectedConfig.name}?`;
    },
  },
  mounted() {
    this.$store.dispatch('crmConfigs/get');
  },
  methods: {
    showAlert(message) {
      this.$set(this.loading, this.selectedConfig.id, false);
      this.selectedConfig = {};
      bus.$emit('newToastMessage', message);
    },
    openAddPopup() {
      this.showAddPopup = true;
    },
    hideAddPopup() {
      this.showAddPopup = false;
    },
    openEditPopup(response) {
      this.showEditPopup = true;
      this.selectedConfig = response;
    },
    hideEditPopup() {
      this.showEditPopup = false;
    },
    openDeletePopup(response) {
      this.showDeleteConfirmationPopup = true;
      this.selectedConfig = response;
    },
    closeDeletePopup() {
      this.showDeleteConfirmationPopup = false;
    },
    confirmDeletion() {
      this.$set(this.loading, this.selectedConfig.id, true);
      this.closeDeletePopup();
      this.$store
        .dispatch('crmConfigs/delete', this.selectedConfig.id)
        .then(() => {
          this.showAlert(this.$t('CRM_CONFIGS.DELETE.API.SUCCESS_MESSAGE'));
        })
        .catch(() => {
          this.showAlert(this.$t('CRM_CONFIGS.DELETE.API.ERROR_MESSAGE'));
        });
    },
  },
};
</script>
